export const membersAreaAppBaseUrl =
  'https://members.wixapps.net/_api/members-area';

export const profileCardTpaBaseUrl =
  'https://members.wixapps.net/profile-card-tpa';

export const membersApiRelativeBaseUrl = '/_api/members-area/_api';

export const membersApiAbsoluteBaseUrl =
  'https://members.wixapps.net/_api/members-area/_api';

export const badgesApiRelativeBaseUrl = '/_api/members-badges-server/v1';
export const badgesApiAbsoluteBaseUrl =
  'https://www.wix.com/_api/members-badges-server/v1';

export const customFieldsApiRelativeBaseUrl = '/_api/members/v1/custom-fields';

export const memberBlockMemberServiceBaseUrl = '/_api/members/';
